import { START } from 'constants/video/status';
import { isMobile } from 'utilities/browser';

export const useStepsViewStyling = ({ identityStatus, videoSeflieCaptureFlag }) => {
    const shouldRemoveBottomMarginOnVideoSelfieMobile = () => {
        return isMobile() && identityStatus === START && videoSeflieCaptureFlag;
    };

    const containerClassName = `prospects-content ${shouldRemoveBottomMarginOnVideoSelfieMobile() && 'remove-margin'}`;

    return { containerClassName };
};
